import default0 from '../assets/img/avatar/default/0.jpg';
import male10 from '../assets/img/avatar/male/10.jpg';
import male11 from '../assets/img/avatar/male/11.jpg';
import male12 from '../assets/img/avatar/male/12.jpg';
import male13 from '../assets/img/avatar/male/13.jpg';
import male14 from '../assets/img/avatar/male/14.jpg';
import male15 from '../assets/img/avatar/male/15.jpg';
import male16 from '../assets/img/avatar/male/16.jpg';
import male17 from '../assets/img/avatar/male/17.jpg';
import male18 from '../assets/img/avatar/male/18.jpg';
import male19 from '../assets/img/avatar/male/19.jpg';
import male20 from '../assets/img/avatar/male/20.jpg';
import male21 from '../assets/img/avatar/male/21.jpg';
import male22 from '../assets/img/avatar/male/22.jpg';
import male23 from '../assets/img/avatar/male/23.jpg';
import male24 from '../assets/img/avatar/male/24.jpg';
import male25 from '../assets/img/avatar/male/25.jpg';
import male26 from '../assets/img/avatar/male/26.jpg';
import male27 from '../assets/img/avatar/male/27.jpg';
import male28 from '../assets/img/avatar/male/28.jpg';
import male29 from '../assets/img/avatar/male/29.jpg';
import male30 from '../assets/img/avatar/male/30.jpg';

import female0 from '../assets/img/avatar/female/0.jpg';
import female1 from '../assets/img/avatar/female/1.jpg';
import female2 from '../assets/img/avatar/female/2.jpg';
import female3 from '../assets/img/avatar/female/3.jpg';
import female4 from '../assets/img/avatar/female/4.jpg';
import female5 from '../assets/img/avatar/female/5.jpg';
import female6 from '../assets/img/avatar/female/6.jpg';
import female7 from '../assets/img/avatar/female/7.jpg';
import female8 from '../assets/img/avatar/female/8.jpg';
import female9 from '../assets/img/avatar/female/9.jpg';
import female10 from '../assets/img/avatar/female/10.jpg';
import female11 from '../assets/img/avatar/female/11.jpg';
import female12 from '../assets/img/avatar/female/12.jpg';
import female13 from '../assets/img/avatar/female/13.jpg';
import female14 from '../assets/img/avatar/female/14.jpg';
import female15 from '../assets/img/avatar/female/15.jpg';
import female16 from '../assets/img/avatar/female/16.jpg';
import female17 from '../assets/img/avatar/female/17.jpg';
import female18 from '../assets/img/avatar/female/18.jpg';
import female19 from '../assets/img/avatar/female/19.jpg';
import female20 from '../assets/img/avatar/female/20.jpg';
import female21 from '../assets/img/avatar/female/21.jpg';
import female22 from '../assets/img/avatar/female/22.jpg';
import female23 from '../assets/img/avatar/female/23.jpg';
import female24 from '../assets/img/avatar/female/24.jpg';
import female25 from '../assets/img/avatar/female/25.jpg';
import female26 from '../assets/img/avatar/female/26.jpg';
import female27 from '../assets/img/avatar/female/27.jpg';
import female28 from '../assets/img/avatar/female/28.jpg';
import female29 from '../assets/img/avatar/female/29.jpg';
import female30 from '../assets/img/avatar/female/30.jpg';
import male0 from '../assets/img/avatar/male/0.jpg';
import male1 from '../assets/img/avatar/male/1.jpg';
import male2 from '../assets/img/avatar/male/2.jpg';
import male3 from '../assets/img/avatar/male/3.jpg';
import male4 from '../assets/img/avatar/male/4.jpg';
import male5 from '../assets/img/avatar/male/5.jpg';
import male6 from '../assets/img/avatar/male/6.jpg';
import male7 from '../assets/img/avatar/male/7.jpg';
import male8 from '../assets/img/avatar/male/8.jpg';
import male9 from '../assets/img/avatar/male/9.jpg';

export default {
  'avatar/default/0': default0,
  'avatar/male/0': male0,
  'avatar/male/1': male1,
  'avatar/male/2': male2,
  'avatar/male/3': male3,
  'avatar/male/4': male4,
  'avatar/male/5': male5,
  'avatar/male/6': male6,
  'avatar/male/7': male7,
  'avatar/male/8': male8,
  'avatar/male/9': male9,
  'avatar/male/10': male10,
  'avatar/male/11': male11,
  'avatar/male/12': male12,
  'avatar/male/13': male13,
  'avatar/male/14': male14,
  'avatar/male/15': male15,
  'avatar/male/16': male16,
  'avatar/male/17': male17,
  'avatar/male/18': male18,
  'avatar/male/19': male19,
  'avatar/male/20': male20,
  'avatar/male/21': male21,
  'avatar/male/22': male22,
  'avatar/male/23': male23,
  'avatar/male/24': male24,
  'avatar/male/25': male25,
  'avatar/male/26': male26,
  'avatar/male/27': male27,
  'avatar/male/28': male28,
  'avatar/male/29': male29,
  'avatar/male/30': male30,

  'avatar/female/1': female1,
  'avatar/female/0': female0,
  'avatar/female/2': female2,
  'avatar/female/3': female3,
  'avatar/female/4': female4,
  'avatar/female/5': female5,
  'avatar/female/6': female6,
  'avatar/female/7': female7,
  'avatar/female/8': female8,
  'avatar/female/9': female9,
  'avatar/female/10': female10,
  'avatar/female/11': female11,
  'avatar/female/12': female12,
  'avatar/female/13': female13,
  'avatar/female/14': female14,
  'avatar/female/15': female15,
  'avatar/female/16': female16,
  'avatar/female/17': female17,
  'avatar/female/18': female18,
  'avatar/female/19': female19,
  'avatar/female/20': female20,
  'avatar/female/21': female21,
  'avatar/female/22': female22,
  'avatar/female/23': female23,
  'avatar/female/24': female24,
  'avatar/female/25': female25,
  'avatar/female/26': female26,
  'avatar/female/27': female27,
  'avatar/female/28': female28,
  'avatar/female/29': female29,
  'avatar/female/30': female30,
};
